<div class="wrap {{alert.background}}" [class.clickable]="alert.video" [style.cursor]="alert.video ? 'pointer' : 'default'" (click)="alert.video ? openDetail(detailModal) : null">
    <div class="layer" *ngIf="alert.layer"><img src="../../../../assets/img/alerts/gifs/{{alert.layer}}" alt=""></div>
    <img class="icon" src="../../../../assets/img/alerts/{{alert.icon}}.png" alt="">
    <div class="text" [class.fix]="alert.button">
        <h5>{{alert.title}}</h5>
        <span [innerHTML]="alert.subtitle" *ngIf="!videoUrl"></span>
    </div>
    <div class="click-hint-badge" *ngIf="alert.video">
        <i class="fa fa-play-circle"></i>
        <span>Ver detalles</span>
    </div>
    <div class="button" *ngIf="alert.button" (click)="alert.button.event(); $event.stopPropagation()">
        <i class="fa fa-{{alert.button.icon}}"></i>
    </div>
    <!-- <i class="fa fa-close" (click)="close(i)"></i> -->
</div>

<ng-template #detailModal let-modal>
    <div class="modal-header {{currentAlert.background}}">
        <div class="modal-header-content">
            <i class="fa fa-{{currentAlert.icon || 'info-circle'}} modal-icon"></i>
            <h4 class="modal-title">{{currentAlert.title}}</h4>
        </div>
        <div class="navigation-controls" *ngIf="allAlerts.length > 1">
            <button class="nav-btn" [disabled]="!hasPrevious" (click)="previousAlert()">
                <i class="fa fa-chevron-left"></i>
            </button>
            <span class="alert-counter">{{currentAlertIndex + 1}} / {{allAlerts.length}}</span>
            <button class="nav-btn" [disabled]="!hasNext" (click)="nextAlert()">
                <i class="fa fa-chevron-right"></i>
            </button>
        </div>
        <button type="button" class="close text-white" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="content-section">
            <h6 class="section-title">Descripción</h6>
            <div class="description-text" [innerHTML]="currentAlert.subtitle"></div>
        </div>
        <div class="video-section" *ngIf="videoUrl">
            <h6 class="section-title">
                <i class="fa fa-{{isImage ? 'picture-o' : 'play-circle'}}"></i> 
                {{isImage ? 'Imagen Informativa' : 'Video Informativo'}}
            </h6>
            <div class="video-container" [class.image-container]="isImage">
                <div *ngIf="isLoadingVideo" class="video-loader">
                    <i class="fa fa-spinner fa-spin fa-3x"></i>
                    <p>Cargando...</p>
                </div>
                <ng-container *ngIf="!isLoadingVideo">
                    <img *ngIf="isImage" 
                         [src]="videoUrl | safe:'resourceUrl'" 
                         class="info-image"
                         alt="Imagen informativa">
                    <video #videoPlayer
                           *ngIf="!isImage && isDirectVideo" 
                           [attr.key]="videoKey"
                           controls 
                           class="video-frame"
                           preload="metadata">
                        <source [src]="videoUrl | safe:'resourceUrl'" type="video/mp4">
                        Tu navegador no soporta la reproducción de video.
                    </video>
                    <iframe *ngIf="!isImage && !isDirectVideo" 
                            [attr.key]="videoKey"
                            [src]="videoUrl | safe:'resourceUrl'" 
                            class="video-frame" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowfullscreen></iframe>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-dark" (click)="modal.dismiss('Close')">
            <i class="fa fa-times"></i> Cerrar
        </button>
    </div>
</ng-template>